import { useState } from "react";

import DashboardContainer from "../../../SharedComponents/DashboardContainer";
import Input from '../../../Auth/Input';
import Button from "../../../SharedComponents/Button";
import Alert, { ALERT_TYPE } from "../../../Auth/Alert";

import { NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";
import { addUserGroup } from "../../../../utils/api";

import { UserIcon, PlusIcon } from "@heroicons/react/solid";
import AccessControl from "../../../SharedComponents/AccessControl";

function AddUser() {
    const [userGroupName, setUserGroupName] = useState("");
    const [alert, setAlert] = useState('');
    const [alertType, setAlertType] = useState(ALERT_TYPE.ERROR);
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleSuccessfulAddUserGroup = async () => {
        setAlert("You've successfully added a User Group");
        setAlertType(ALERT_TYPE.SUCCESS);
    }

    const handleAddUserGroup = async () => {
        try {
            setSubmitLoading(true);

            await addUserGroup(userGroupName);
            await handleSuccessfulAddUserGroup();

            setSubmitLoading(false);
        } catch (err) {
            setSubmitLoading(false);

            setAlertType(ALERT_TYPE.ERROR);
            setAlert(err.message);
        }
    }

    return (
        <AccessControl requiredPermission={PERMISSIONS.CREATE_USER_GROUPS} noAccessType={NO_ACCESS_TYPES.REDIRECT}>
            <DashboardContainer title={"Add User Group"} titleIcon={<PlusIcon className="block h-5 w-5 mr-2"/>}>
                <div className="grid grid-flow-row gap-4">
                    <div className="md:col-span-1">
                        <div>
                            <h3 className="text-md font-medium leading-6 text-indigo-900">
                                User Group details
                            </h3>
                            <p className="text-sm text-gray-600">
                                Please complete the form below to add a User Group
                            </p>
                        </div>
                    </div>
                    <div>
                        <form action="#" method="POST">
                            <Alert
                                text={alert}
                                type={alertType}
                                active={alert}
                                close={() => setAlert("")}
                            />
                            <div className="shadow-sm overflow-hidden rounded-md">
                                <div className="grid grid-flow-row gap-4 md:gap-6 p-4 bg-white">
                                    <div className={"grid grid-flow-row md:grid-cols-6 gap-4 md:gap-6"}>
                                        <div className={"col-span-full md:col-span-3"}>
                                            <Input
                                                type="text"
                                                name="User Group name"
                                                id="userGroupName"
                                                placeholder={"User Group name"}
                                                onChange={setUserGroupName}
                                                Icon={<UserIcon className="h-4 w-4 text-gray-500"/>}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="p-4 bg-gradient-to-l from-primary-50 to-secondary-50 flex items-center justify-end text-right">
                                    <Button
                                        text="Add User Group"
                                        icon={<PlusIcon className="block h-4 w-4 mr-2"/>}
                                        iconPositionLeft
                                        onClick={handleAddUserGroup}
                                        loading={submitLoading}
                                        extraStyling={
                                            "text-white focus:ring-inset focus:ring-1 bg-secondary-500 " +
                                            "hover:bg-secondary-600 focus:outline-none focus:ring-secondary-500"
                                        }
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </DashboardContainer>
        </AccessControl>
    );
}

export default AddUser;